<i2g-card *ngIf="summaryData$ | async as summary" class="content-wrapper">
  <a
    *ngIf="summaryCtaRoute$ | async as summaryCta"
    class="summary-cta"
    [routerLink]="summaryCta.route"
    i2gTrackable
    [trackingObject]="trackingObject"
    [trackingAction]="summaryCta.trackingAction"
    [trackingAdditionalProperties]="summaryCta.trackingAdditionalProperties"
  >
    {{ summary.cta.title }}
  </a>

  <p class="title" [ngClass]="summary.type">
    {{ summary.title }} ({{ summary.quantity }})
  </p>

  <p *ngIf="summary.additionalNote" class="note">
    {{ summary.additionalNote }}
  </p>

  <p class="total-amount">
    {{ summary.totalAmount | money: summary.currencyCode:locale }}
  </p>

  <ng-container *ngIf="showEmptyState$ | async; else summaryTemplate">
    <div class="empty-state-wrapper">
      <p class="empty-state-message">
        {{
          'HOME.INSIGHTS_HUB.EMPTY_STATE_MESSAGE.' + reportType
            | uppercase
            | translate
        }}
      </p>

      <i2g-router-link
        class="empty-state-cta"
        *ngIf="emptyStateCta$ | async as emptyStateCta"
        buttonStyle="tertiary"
        [label]="emptyStateCta.label | translate"
        [route]="emptyStateCta.route"
        i2gTrackable
        [trackingObject]="trackingObject"
        [trackingAction]="emptyStateCta.trackingAction"
        [trackingAdditionalProperties]="
          emptyStateCta.trackingAdditionalProperties
        "
        [alignment]="'center'"
      ></i2g-router-link>
    </div>
  </ng-container>

  <ng-template #summaryTemplate>
    <div
      *ngIf="summary.barGraph; else summaryItemList"
      class="bar-graph-container"
    >
      <p *ngIf="showSummaryAverage$ | async" class="chart-message">
        {{
          'HOME.INSIGHTS_HUB.GRAPH.MONTHLY_AVERAGE'
            | translate
              : {
                  amount:
                    summary.barGraph.quantity
                    | money: summary.currencyCode:locale
                }
        }}
      </p>

      <app-bar-chart
        *ngIf="barChartContent$ | async as barChartContent"
        [barChart]="barChartContent"
        [trackingObject]="trackingObject"
        [trackingScreenName]="trackingScreenName"
        [trackingAdditionalProperties]="trackingAdditionalProperties"
        class="bar-chart"
      >
      </app-bar-chart>
    </div>

    <ng-template #summaryItemList>
      <div class="summary-list-items-wrapper">
        <app-insights-summary-card-item
          *ngFor="let item of summaryDataItems$ | async"
          [item]="item"
          [currencyCode]="summary.currencyCode"
          [reportType]="reportType"
          [trackingScreenName]="trackingScreenName"
        >
        </app-insights-summary-card-item>
      </div>
    </ng-template>
  </ng-template>
</i2g-card>
